export const DEFAULT_STALE_TIMES = {
  statistics: 60 * 1000
}
